import { Combobox, type ComboboxOption } from '@klear/ui/components/combobox'
import { Label } from '@klear/ui/components/label'
import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import { useTraders } from '@klear/ui/hooks/use-traders'
import { useMemo } from 'react'
import toString from 'lodash/toString'
import type { CollectionStepCtx } from '@/app/collections/outlet-context'

export default function SelectTraderStep({ ctx }: WizardStepComponentProps<CollectionStepCtx>) {
  const { state, setState } = ctx
  const traderId = state.traderId

  const { traders = [] } = useTraders()
  const traderOptions = useMemo<ComboboxOption[]>(
    () =>
      traders.map((t) => ({
        value: toString(t.id),
        label: t.name ?? toString(t.id)
      })),
    [traders]
  )

  const onTraderChange = (value: string) => {
    const id = value ? parseInt(value, 10) : null
    setState((s) => ({
      ...s,
      traderId: id,
      selectedFees: [],
      selectedRecoveries: [],
      paymentDetails: null
    }))
  }

  return (
    <div className="space-y-4 w-full">
      <p className="text-sm text-muted-foreground">Select the trader to collect from.</p>
      <div className="space-y-2">
        <Label className="text-sm font-medium">Trader</Label>
        <Combobox
          options={traderOptions}
          value={traderId != null ? toString(traderId) : ''}
          onChange={onTraderChange}
          triggerLabel="Select trader..."
          placeholder="Search traders..."
        />
      </div>
    </div>
  )
}
